import SearchInput from 'components/SearchInput'
import styled from 'styled-components'

const SearchControls = styled.div`
  grid-column: meta;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 22rem;
`

const StyledSigCodeSearch = styled(SearchInput)`
  height: 2.25rem;
  margin-left: 0rem;
  input {
    margin-left: 0rem;
  }
`

const TableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
`

export { SearchControls, StyledSigCodeSearch, TableWrapper }
